function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 15.134a1 1 0 010 1.732L12 22.928a1 1 0 01-1.5-.866V9.938a1 1 0 011.5-.866l10.5 6.062z",
  fill: "#2F80ED"
});

var SvgIconVideo = function SvgIconVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjUgMTUuMTM0QzIzLjE2NjcgMTUuNTE4OSAyMy4xNjY3IDE2LjQ4MTEgMjIuNSAxNi44NjZMMTIgMjIuOTI4MkMxMS4zMzMzIDIzLjMxMzEgMTAuNSAyMi44MzIgMTAuNSAyMi4wNjIyTDEwLjUgOS45Mzc4MkMxMC41IDkuMTY4MDIgMTEuMzMzMyA4LjY4NjkgMTIgOS4wNzE4TDIyLjUgMTUuMTM0WiIgZmlsbD0iIzJGODBFRCIvPgo8L3N2Zz4K";
export { SvgIconVideo as ReactComponent };